'use client';

import { WatchVideoBtn } from '@/components/WatchVideoBtn';
import Grid from '@/components/_rebrand/Grid';
import { TextCombination } from '@/components/_rebrand/TextCombination';
import ThemeWrapper from '@/components/_rebrand/ThemeWrapper';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { FC } from 'react';

export type MediaSectionAnimation = 'static' | 'scale';

export type MediaSectionProps = {
  title: string;
  description: string;
  thumbnailSrc: string;
  thumbnailAlt: string;
  onAssetClick?: (mediaItemId: string) => void;
  videoId?: string;
  animation?: MediaSectionAnimation;
};

const MediaSection: FC<MediaSectionProps> = ({
  title,
  description,
  thumbnailSrc,
  thumbnailAlt,
  onAssetClick,
  videoId,
  animation = 'scale',
}) => (
  <ThemeWrapper theme="theme-gray">
    <section className="surface-l0 py-margin-section-md">
      <Grid className="gap-y-3xl">
        <div className="col-span-4 md:col-span-12">
          <TextCombination
            type="d2p1"
            headingLevel="h3"
            align="center"
            title={title}
            description={description}
          />
        </div>
        <div className="col-span-4 md:col-span-12">
          <motion.div
            className="relative flex flex-col items-center justify-center rounded-10 overflow-hidden cursor-pointer"
            whileHover={animation === 'scale' ? { scale: 1.02 } : undefined}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            onClick={() => onAssetClick?.(videoId ?? '')}
          >
            <Image
              src={thumbnailSrc}
              alt={thumbnailAlt}
              width={1280}
              height={720}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 flex items-center justify-center w-full h-full">
              <WatchVideoBtn />
            </div>
          </motion.div>
        </div>
      </Grid>
    </section>
  </ThemeWrapper>
);

export default MediaSection;
